import useSWR from 'swr';
import { useTranslation } from 'react-i18next';
import { getNestedDataFetcher } from '@/utils/apis';

/**
 * v1 근태 상세 조회 + 셀 표기 도우미.
 * 응답 전엔 '-', 실패면 안내 문구 — 레거시 조회 폼과 같은 셀 단위 폴백.
 */
const useAttendanceDetail = <T>(url: string | null) => {
  const { t } = useTranslation();
  const { data, error, isLoading } = useSWR<T>(
    url,
    (key: string) => getNestedDataFetcher<T>(key),
    { revalidateOnFocus: false },
  );

  const fallback = error ? t('데이터를 불러오지 못했습니다.') : '-';
  const cell = (render: (detail: T) => string): string =>
    data ? render(data) : fallback;

  return { data, error, isLoading, cell };
};

export default useAttendanceDetail;
